module.exports = __webpack_public_path__ + "img/pt-29.126c7142.jpg";